import { useQuery } from '@tanstack/react-query';
import { listSessionExchangesV2HousesHouseIdAssistantSessionsSessionIdExchangesGetOptions } from '@/client/@tanstack/react-query.gen.ts';

/**
 * Fetches all exchanges (turns) for a given session, ordered most-recent-first.
 * Reverse the result before rendering to display chronologically.
 * Only runs when sessionId is provided.
 */
interface UseAssistantExchangesOptions {
	reconcileOnMount?: boolean;
}

export const useAssistantExchanges = (
	houseId: number,
	sessionId: string | null,
	options: UseAssistantExchangesOptions = {},
) => {
	return useQuery({
		...listSessionExchangesV2HousesHouseIdAssistantSessionsSessionIdExchangesGetOptions({
			path: { house_id: houseId, session_id: sessionId! },
		}),
		enabled: sessionId != null,
		...(options.reconcileOnMount ? { refetchOnMount: 'always' as const } : {}),
	});
};
